import { useMutation } from '@tanstack/vue-query';
import { rootService } from '@/api/root.service';

export const useReloadFeatureFlags = () => {
  return useMutation({
    mutationKey: ['reload-feature-flags'],
    mutationFn: () => rootService.reloadFeatureFlags(),
  });
};
